import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Nigerian National Identification Number validator following Single Responsibility Principle
 */
export class NgValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Nigerian NIN',
      pattern: /^\d{11}$/,
      length: 11
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Nigerian NIN must be exactly 11 digits'
    );
  }

  validateChecksum(id) {
    // NIN uses a specific algorithm
    const weights = [3, 7, 3, 7, 3, 7, 3, 7, 3, 7];
    let sum = 0;

    for (let i = 0; i < 10; i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    const expectedChecksum = sum % 10;
    const actualChecksum = parseInt(id[10]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid NIN checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Nigerian NIN');
  }
}